import { createApi, fetchBaseQuery, FetchBaseQueryError } from '@reduxjs/toolkit/query/react'
import { apiPath, baseUrl } from 'config'

type SignedUrlArgs = {
  amount: string
  currency: string
  wallet: string
}

type SignedUrlResponse = {
  url: string
}

export const queryUnlimit = createApi({
  baseQuery: fetchBaseQuery({ baseUrl }),
  endpoints: (builder) => ({
    getUnlimitSignedUrl: builder.query<SignedUrlResponse, SignedUrlArgs>({
      queryFn: async ({ amount, currency, wallet }, _api, _extraOptions, baseQuery) => {
        const url = `${apiPath.unlimitSignedUrl}?wallet=${wallet}&amount=${amount}&currency=${currency}`

        const result = await baseQuery({ url })

        if (!result.data) {
          return { error: result.error as FetchBaseQueryError }
        }

        return { data: result.data as SignedUrlResponse }
      },
    }),
  }),
  reducerPath: 'unlimit',
})

export const { useLazyGetUnlimitSignedUrlQuery } = queryUnlimit
